import React from 'react';
import './Copyright.scss';
const Copyright = () => {
    return (
        <div className='footer__foot'>
            <p>
                &copy; {new Date().getFullYear()} Solucionarte. Desarrollado por{' '}
                <a href='http://www.onetech.ar' rel='nofollow'>
                    Onetech
                </a>
            </p>
        </div>

    )
}

export default Copyright;
